import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-50 pt-20 pb-10 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Column 1: IANOS */}
          <div>
            <Link to="/" className="text-2xl font-bold text-primary tracking-tight mb-4 block">
              Ianos
            </Link>
            <p className="text-text-muted max-w-xs">
              Everyone gets what they need to do their best work.
            </p>
          </div>

          {/* Column 2: PRODUCT */}
          <div>
            <h4 className="font-bold text-primary mb-6 uppercase tracking-wider text-sm">Product</h4>
            <ul className="space-y-4">
              <li>
                <a href="#how-it-works" className="text-text-muted hover:text-accent transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#features" className="text-text-muted hover:text-accent transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="https://app.ianos.io" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-accent transition-colors">
                  Request Demo
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: COMPANY */}
          <div>
            <h4 className="font-bold text-primary mb-6 uppercase tracking-wider text-sm">Company</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/about" className="text-text-muted hover:text-accent transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a href="mailto:nicola.sarli@ianos.io" className="text-text-muted hover:text-accent transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/ianosinc/" target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-accent transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-text-light">
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
          <div>
            © 2026 Ianos. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
